import { render, staticRenderFns } from "./BalanceCardComponent.vue?vue&type=template&id=fc597782&scoped=true&"
import script from "./BalanceCardComponent.vue?vue&type=script&lang=js&"
export * from "./BalanceCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc597782",
  null
  
)

export default component.exports